import React from "react";
import { Paper, Typography, makeStyles } from "@material-ui/core";
import DOMPurify from "dompurify";

const useStyles = makeStyles((theme) => ({
    emailViewer: {
        padding: theme.spacing(3),
        "& img": {
            maxWidth: "100%",
            height: "auto",
        },
        "& a": {
            color: theme.palette.primary.main,
        },
    },
}));

const EmailViewer = ({ htmlBody, textBody }) => {
    const classes = useStyles();

    // Sanitizar HTML para prevenir XSS
    const sanitizedHtml = htmlBody
        ? DOMPurify.sanitize(htmlBody, {
            ALLOWED_TAGS: [
                "p", "br", "strong", "em", "u", "h1", "h2", "h3", "h4", "h5", "h6",
                "ul", "ol", "li", "a", "img", "table", "thead", "tbody", "tr", "th", "td",
                "div", "span", "blockquote", "pre", "code"
            ],
            ALLOWED_ATTR: ["href", "src", "alt", "title", "style", "class"],
            ALLOW_DATA_ATTR: false,
        })
        : null;

    return (
        <Paper className={classes.emailViewer} variant="outlined">
            {sanitizedHtml ? (
                <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
            ) : (
                <Typography
                    component="pre"
                    style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}
                >
                    {textBody || "(E-mail vazio)"}
                </Typography>
            )}
        </Paper>
    );
};

export default EmailViewer;
